<template>
  <div id="app">

    <div class="sticky-nav px-4">

    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
      <h1 class="h2">Stortplaatsen</h1>
    </div>

    <div class="dropdown">
      <button class="btn btn-dark" type="button" id="dropdownMenuButton" v-on:click="modalToevoegenStortplaats()">
        <i class="fas fa-plus"></i> Stortplaats toevoegen
      </button>
    </div>

    </div>

    <br /><br />

    <vue-good-table v-if="stortplaatsen && stortplaatsen.length"
          class="mb-3 px-4"
          @on-selected-rows-change="selectionChanged"
          @on-cell-click="onRowClick"
          :columns="stortplaatsColumns"
          :rows="stortplaatsen"
          :pagination-options="{
            enabled: true,
            mode: 'pages',
            perPage: 100,
            position: 'bottom',
            perPageDropdown: [25, 50, 100],
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
            dropdownAllowAll: true,
          }"
          :selectOptions="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
          }"
    />

    <!-- Modal -->
    <div class="modal fade" id="stortplaatsModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ editModalTitle }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

              <div v-if="stortplaats">
                <label>Beschrijving</label><input type="text" class="form-control" v-model="stortplaats.beschrijving" placeholder="Beschrijving" />
                <label>Straat</label><input type="text" class="form-control" v-model="stortplaats.straat" placeholder="Straat" />
                <label>Huisnummer</label><input type="text" class="form-control" v-model="stortplaats.huisnummer" placeholder="Huisnummer" />
                <label>Postcode</label><input type="text" class="form-control" v-model="stortplaats.postcode" placeholder="Postcode" />
                <label>Gemeente</label><input type="text" class="form-control" v-model="stortplaats.gemeente" placeholder="Gemeente" />
                <label>Land</label><input type="text" class="form-control" v-model="stortplaats.land" placeholder="Land" />
                <label>Ondernemingsnr.</label><input type="text" class="form-control" v-model="stortplaats.ondernemingsnummer" placeholder="Ondernemingsnummer" />
              </div>

          </div>
          <div class="modal-footer">
            <button v-if="checkNewStortplaats === false" type="button" class="btn btn-danger" v-on:click="deleteStortplaats()">Verwijderen</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Sluiten</button>
            <button v-if="checkNewStortplaats" type="button" class="btn btn-primary" v-on:click="createStortplaats()">Opslaan</button>
            <button v-else type="button" class="btn btn-primary" v-on:click="updateStortplaats()">Aanpassen</button>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>

import $ from 'jquery';
import 'bootstrap';
import axios from 'axios';

export default {
  name: 'app',
  components: {

  },
  data() {
    return{
      checkNewStortplaats: false,
      importType : '-1',
      importCategory: '-1',
      types: [
        {
          name: 'Stortplaatsen'
        },
        {
          name: 'Stortplaatsen'
        },
        {
          name: 'Leveradressen'
        }
      ],
      editModalTitle: '',
      stortplaats: {
      },
      contacten: {},
      stortplaatsen: {
        attributes: [],
        related: []
      },
      stortplaatsColumns: [
        {label: 'Beschrijving', field: 'beschrijving', filterOptions: {enabled: true}},
        {label: 'Adres', field: this.adresFn, filterOptions: {enabled: true}},
        {label: 'Postcode', field: 'postcode', filterOptions: {enabled: true}},
        {label: 'Gemeente', field: 'gemeente', filterOptions: {enabled: true}},
        {label: 'Land', field: 'land', filterOptions: {enabled: true}}
      ],
      attrPos: 0
    }
  },
  mounted (){
    this.getStortplaatsen();
    this.getContacten();
  },
  methods: {
    contactFn(rowObj){

      var contacten = this.contacten;
      var contact_id = rowObj.contact;

      for(var i = 0; i < contacten.length ; i++){
        if(contacten[i]['id'] == contact_id){
          return contacten[i]['naam'] + ' ' + contacten[i]['voornaam'];
        }
      }

    },
    adresFn(rowObj){

      return rowObj.straat + ' ' + rowObj.huisnummer;

    },
    getStortplaatsen(){

      axios
        .get('https://hofman.weblion.be/api/stortplaatsen/')
        .then(response => {
          this.stortplaatsen = response.data;
          console.log(this.stortplaatsen);
        })
    },
    getContacten(){

      axios
        .get('https://hofman.weblion.be/api/contacten/')
        .then(response => {
          this.contacten = response.data;
          console.log(this.stortplaatsen);
        })
    },
    deleteStortplaats(){

      axios
        .delete('https://hofman.weblion.be/api/stortplaatsen/', { data: {
          stortplaats_id : this.stortplaats.id
        }})
        .then(response => {
          this.getStortplaatsen();
          $("#stortplaatsModal").modal('hide');
          console.log(response.data);
        })

    },
    updateStortplaats(){

      axios.put('https://hofman.weblion.be/api/stortplaatsen/', {
        stortplaats : this.stortplaats
      })
      .then(response => {
        this.getStortplaatsen();
        $("#stortplaatsModal").modal('hide');
        console.log(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });

    },
    createStortplaats(){

      axios.post('https://hofman.weblion.be/api/stortplaatsen/', {
        stortplaats : this.stortplaats
      })
      .then(response => {
        this.getStortplaatsen();
        $("#stortplaatsModal").modal('hide');
        console.log(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });

    },
    modalToevoegenStortplaats(){
      this.stortplaats = {};
      this.editModalTitle = 'Stortplaats toevoegen';

      this.checkNewStortplaats = true;

      $("#stortplaatsModal").modal('show');
    },
    onRowClick(table){

      this.editModalTitle = 'Stortplaats aanpassen';
      this.stortplaats = table.row;

      this.checkNewStortplaats = false;

      $("#stortplaatsModal").modal('show');
    },
    selectionChanged(table){
      this.stortplaatsenSelected = table.selectedRows;
    },
    modalAanpassenStortplaats(){

      this.checkNewStortplaats = false;
      this.editModalTitle = 'Stortplaats aanpassen';

      $("#stortplaatsModal").modal('show');

    },
    sStortplaats(){

      axios
        .post('https://hofman.weblion.be/api/stortplaatsen/update.php',{
          stortplaats : this.stortplaats
        })
        .then((res) => {
          console.log(res);
          this.getStortplaatsen();
        })
        .then(function(){ $("#stortplaatsModal").modal('hide'); })

    }


  }
}
</script>

<style>
button{
  margin-right: 10px;
}
.table thead th{
  text-align: left !important;
}
.pager ul{
  list-style-type: none;
}
.pager ul li{
  display: inline-block;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 5px;
  width: 40px;
  text-align: center;
  margin: 2px;
}
.modal input,.modal select{
  margin-bottom: 5px;
}
.modal-body label{
  display: inline-block;
  width: 32%;
}

.modal-body .form-control{
  display: inline-block;
  width: 68%;
}

.modal-body select{
  text-indent: 5px;
}

#exampleModal input{
  display: block;
  width: 100%;
}

#importModal .modal-body label{
  width: auto;
}

#importModal input, #importModal select{
  display: inline-block;
  width: 49%;
  margin-bottom: 5px;
}

#importModal .match-wrapper, #importModal form{
  width: 100%;
}
#importModal select{
  margin-left: 1%;
}

#importModal .fullw{
  display: block;
  width: 100%;
  border-radius: 4px;
}

#importModal .fullw select{
  margin: 0;
}

#importModal .fullw input{
  display: block;
  width: 100%;
  margin: 0;
}

.dropdown{
  display: inline-block;
}
.dropdown-item:hover{
  cursor: pointer !important;
}
.dropdown-item i{
  margin-right:3px;
}
@media (min-width: 576px){
  .modal-dialog {
      max-width: 550px;
      margin: 1.75rem auto;
  }
}
.groupedState{
  display: inline-block;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  margin-left: 25%;
}

#autoGroupModal table tr td{
  padding: 2px 10px;
}

#autoGroupModal .modal-title span{
  color: #777;
  font-size: 14px;
  margin-left: 10px;
}

#autoGroupModal input{
  width: 100%;
}

#autoGroupModal .form-check-input{
  width: auto;
  position: relative;
  margin: 0;
  vertical-align: 2px;
}

.ck.ck-editor {
    display: inline-block !important;
    width: 68% !important;
    margin-bottom: 5px !important;
}

.sticky-nav{
  position: fixed;
    height: 150px;
    top: 50;
    z-index: 2;
    background: white;
    padding-top: 10px;
        width: 100%;
        margin-top: -10px;
}

#stortplaatsModal textarea{
  height: 100px;
}

.vgt-wrap{
  margin-top: 120px;
}

label{
  vertical-align: top;
}

[data-g='1']{
  background: #8CC040;
}

[data-g='0']{
  background: red;
}
.btn-danger{
  margin-right: 210px;
}
</style>
